/**
 * @var ScriptData
 */

let Choices = require( 'choices.js' );

let forms = ( function ($) {

	let $forms;

	let is_ie;

	let choices = {};

	let _init = function ( e ) {
		let ua = window.navigator.userAgent;
		is_ie = ua.indexOf("MSIE") > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);

		$forms = $( '.crate-form' );

		if ( $forms.length > 0 ) {
			$forms.each( function() {
				let $form = $( this );

				$form.on( 'submit', _submit );

				let $fields = _get_fields( $form );

				$fields.each( function() {
					let $field = $( this );

					if ( $field.is( 'select' ) ) {
						if ( ! is_ie ) {
							choices[ $field.attr( 'id' ) ] = new Choices( $field.get( 0 ), {
								shouldSort: false,
								removeItemButton: true
							} );
						}
					}

					$field.on( 'change', _field_change );
				} );
			} );

			let $tooltips = $( '.crate-tooltip' );

			$tooltips.each( function() {
				let $tooltip = $( this );

				$tooltip.find( '.tooltip-icon' ).on( 'click', _maybe_show_tooltip );
				$tooltip.find( '.tooltip-close' ).on( 'click', _hide_tooltip_event );
			} );

			init_save_buttons();
		}
	};

	let init_save_buttons = function() {
		let $buttons = $( '.save-form' );

		$buttons.each( function() {
			let $button = $( this );

			$button.off( 'click', _save_button_event );
			$button.on( 'click', _save_button_event );
		} );
	};

	let _save_button_event = function( e ) {
		e.preventDefault();

		let $button = $( this );

		let form_id = $button.data( 'form' );
		let redirect = $button.data( 'redirect' );
		redirect = typeof redirect === 'undefined' ? false : redirect;
		let save_source = $button.data( 'savesource' );
		save_source = typeof save_source === 'undefined' ? false : save_source;

		let $form = $( '#' + form_id );

		_post_data( $form, false, true, redirect, save_source )
	};

	let _maybe_show_tooltip = function ( e ) {
		if ( ! $( this ).closest( '.crate-tooltip' ).hasClass( 'open' ) ) {
			_show_tooltip( $( this ).closest( '.crate-tooltip' ) );
		}
	};

	let _hide_tooltip_event = function ( e ) {
		e.preventDefault();

		_hide_tooltip( $( this ).closest( '.crate-tooltip' ) );
	};

	let _hide_tooltip = function ( $tooltip ) {
		$tooltip.removeClass( 'open' );
	};

	let _show_tooltip = function ( $tooltip ) {
		$tooltip.addClass( 'open' );
	};

	let _get_fields = function ( $form ) {
		return $form.find( '.crate-field' );
	};

	let _get_field_values = function ( $form ) {
		let $fields = _get_fields( $form );

		let values = {};

		$fields.each( function() {
			let $field = $( this );

			let field_name = $field.attr( 'name' );
			let value_key  = field_name.replace( $form.attr( 'id' ) + '-', '' );

			values[ value_key ] = _get_field_value( $form, field_name );
		} );

		return values;
	};

	let _get_field_value = function ( $form, field_name ) {
		let $fields = $form.find( '[name="' + field_name + '"]' );

		if ( ! $fields.length > 0 ) {
			return null;
		}

		if ( $fields.length > 1 ) {
			let type  = $fields.first().attr( 'type' );
			type = type ? type : '';
			let value = [];

			$fields.each( function() {
				let $field = $( this );

				if ( $field.is( ':checked' ) ) {
					if (  'checkbox' === type.toLowerCase() ) {
						value.push( $field.val() );
					} else {
						value = $field.val();
						return;
					}
				}
			} );

			return value;
		} else {
			let $field = $fields.first();

			let type  = $field.attr( 'type' );
			type = type ? type : '';

			if (  'checkbox' === type.toLowerCase() ) {
				return $field.is( ':checked' ) ? [ $field.val() ] : [];
			}

			return $field.val();
		}

	};

	let _get_nonce = function ( $form ) {
		return _get_field_value( $form, '_wpnonce' );
	};

	let _field_change = function ( e ) {
		_post_data( $( this ).closest( 'form' ), true, false, false, false );
	};

	let _submit = function ( e ) {
		e.preventDefault();

		_post_data( $( this ), false, false, false, false );
	};

	let _post_data = function ( $form, autosave, manual_save, redirect, save_source ) {
		let values = _get_field_values( $form );

		if ( !autosave && ! manual_save ) {
			$form.addClass( 'show-notices' );
		}

		if ( ! autosave || manual_save ) {
			show_spinner( $form );
		}

		let request = new XMLHttpRequest();

		request.open( 'POST', ScriptData.ajaxurl, true );
		request.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded;' );
		request.onload = _post_data_response;

		let data = {
			action: 'crate_submit_form',
			form_id: $form.attr( 'id' ),
			nonce: _get_nonce( $form ),
			current_uri: window.location.href,
			autosave: autosave,
			values: values,
			manual_save: manual_save,
			redirect: redirect,
			save_source: save_source
		};

		request.send( 'action=crate_submit_form&form_data=' + encodeURIComponent( JSON.stringify( data ) ) );
	};

	let _post_data_response = function () {
		let response = JSON.parse( this.response );

		let $form = $( '#' + response.form_id );

		$form.trigger( 'form_submitted', response );
		$( document ).trigger( response.form_id + '_submitted', response );

		if ( ! response.manual_save && $form.hasClass( 'show-notices' ) ) {
			display_field_errors( $form, response.field_errors );
			display_form_errors( $form, response.form_errors );
		}

		display_field_notices( $form, response.field_notices );
		display_form_notices( $form, response.form_notices );

		_update_field_values( $form, response.updated_values );
		_hide_fields( $form, response.hide_fields );

		if ( response.update_url ) {
			window.history.replaceState(null, '', response.update_url );
		}

		let $error_div = $form.find( '.form-errors' );
		let $notices_div = $form.find( '.form-notices' );
		let did_scroll = false;

		if ( ! response.autosave && ( $error_div.hasClass( 'has-errors' ) || $notices_div.hasClass( 'has-notices' ) ) ) {
			$( 'html, body' ).animate( {
				scrollTop: $form.offset().top - 150
			}, 1000 );

			did_scroll = true;
		}

		if ( response.valid && response.redirect ) {
			let timeout = did_scroll ? 1500 : 500;
			setTimeout( function () {
				window.location.href = response.redirect
			}, timeout );
		} else {
			hide_spinner( $form );
		}
	};

	let _update_field_values = function ( $form, values ) {
		for ( let field in values ) {
			if ( !values.hasOwnProperty( field ) ) {
				continue;
			}

			let el_id = $form.attr( 'id' ) + '-' + field;
			let $el = $( '#' + el_id );

			if ( $el.is( 'select' ) ) {
				if ( typeof choices[ el_id ] !== 'undefined' ) {
					choices[ el_id ].setChoiceByValue( values[ field ] );
				} else {
					$el.val( values[ field ] );
				}
			} else {
				$el.val( values[ field ] );
			}
		}
	};

	let _hide_fields = function ( $form, fields ) {
		for ( let field in fields ) {
			if ( !fields.hasOwnProperty( field ) ) {
				continue;
			}

			let $el = $( '#' + $form.attr( 'id' ) + '-field-wrap-' + field );

			if ( fields[ field ] ) {
				$el.addClass( 'js-hide' );
			} else {
				$el.removeClass( 'js-hide' );
			}
		}
	};

	let display_field_errors = function ( $form, errors ) {
		let form_id = $form.attr( 'id' );

		for ( let field in errors ) {
			if ( !errors.hasOwnProperty( field ) ) {
				continue;
			}

			let $field_wrap = $( '#' + form_id + '-field-wrap-' + field );
			let $error_div = $field_wrap.find( '.field-errors' );

			$field_wrap.removeClass( 'has-errors' );
			$error_div.removeClass( 'has-errors' );

			$error_div.empty();

			for ( let error_key in errors[field] ) {
				if ( !errors[field].hasOwnProperty( error_key ) ) {
					continue;
				}

				let $existing_error = $error_div.find( '.' + error_key );

				if ( $existing_error.length > 0 ) {
					$existing_error.remove();
				}

				$error_div.append( '<span class="' + error_key + '">' + errors[field][error_key] + '</span>' );
			}

			if ( $error_div.children().length > 0 ) {
				$field_wrap.addClass( 'has-errors' );
				$error_div.addClass( 'has-errors' );
			}
		}
	};

	let display_field_notices = function ( $form, notices ) {
		let form_id = $form.attr( 'id' );

		for ( let field in notices ) {
			if ( !notices.hasOwnProperty( field ) ) {
				continue;
			}

			let $field_wrap = $( '#' + form_id + '-field-wrap-' + field );
			let $notice_div = $field_wrap.find( '.field-notices' );

			$field_wrap.removeClass( 'has-notices' );
			$notice_div.removeClass( 'has-notices' );

			$notice_div.empty();

			for ( let notice_key in notices[field] ) {
				if ( !notices[field].hasOwnProperty( notice_key ) ) {
					continue;
				}

				let $existing_notice = $notice_div.find( '.' + notice_key );

				if ( $existing_notice.length > 0 ) {
					$existing_notice.remove();
				}

				$notice_div.append( '<span class="' + notice_key + '">' + notices[field][notice_key] + '</span>' );
			}

			if ( $notice_div.children().length > 0 ) {
				$field_wrap.addClass( 'has-notices' );
				$notice_div.addClass( 'has-notices' );
			}
		}
	};

	let display_form_errors = function ( $form, errors ) {
		let $error_div = $form.find( '.form-errors' );

		$error_div.removeClass( 'has-errors' );
		$error_div.empty();

		for ( let error_key in errors ) {
			if ( !errors.hasOwnProperty( error_key ) ) {
				continue;
			}

			let $existing_error = $error_div.find( '.' + error_key );

			if ( $existing_error.length > 0 ) {
				$existing_error.remove();
			}

			$error_div.append( '<span class="' + error_key + '">' + errors[error_key] + '</span>' );
		}

		if ( $error_div.children().length > 0 ) {
			$error_div.addClass( 'has-errors' );
		}
	};

	let display_form_notices = function ( $form, notices ) {
		let $notice_div = $form.find( '.form-notices' );

		$notice_div.removeClass( 'has-notices' );
		$notice_div.empty();

		for ( let notice_key in notices ) {
			if ( !notices.hasOwnProperty( notice_key ) ) {
				continue;
			}

			let $existing_notice = $notice_div.find( '.' + notice_key );

			if ( $existing_notice.length > 0 ) {
				$existing_notice.remove();
			}

			$notice_div.append( '<span class="' + notice_key + '">' + notices[notice_key] + '</span>' );
		}

		if ( $notice_div.children().length > 0 ) {
			$notice_div.addClass( 'has-notices' );
		}
	};

	let show_spinner = function ( $form ) {
		$( 'body' ).addClass( 'crate-loading' );
		let $spinners = $form.find( '.ajax-spinner' );

		$spinners.each( function() {
			$( this ).addClass( 'active' );
		} );
	};

	let hide_spinner = function ( $form ) {
		$( 'body' ).removeClass( 'crate-loading' );
		let $spinners = $form.find( '.ajax-spinner' );

		$spinners.each( function() {
			$( this ).removeClass( 'active' );
		} );
	};

	$( document ).ready( _init );

	return {
		choices: choices,
		init_save_buttons: init_save_buttons,
		display_field_errors: display_field_errors,
		display_field_notices: display_field_notices,
		display_form_errors: display_form_errors,
		display_form_notices: display_form_notices,
		show_spinner: show_spinner,
		hide_spinner: hide_spinner
	}

})(jQuery);

module.exports = forms;